export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="accueil" className="relative min-h-screen flex items-center justify-center">
      {/* Fond divisé en 3 visuels représentant chaque service */}
      <div className="absolute inset-0 flex">
        <div className="relative flex-1 overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/5b83ad73dbc332833b90390d0cd3d56a.jpg"
            alt="Dératisation"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
          <div className="absolute bottom-4 left-0 right-0 text-center px-4">
            <div className="inline-flex items-center gap-2 bg-brand-600/90 text-white text-sm font-semibold px-4 py-2 rounded-full">
              <i className="ri-bug-line"></i> Dératisation
            </div>
          </div>
        </div>
        <div className="relative flex-1 overflow-hidden border-x border-white/10">
          <img
            src="https://readdy.ai/api/search-image?query=macro%20close%20up%20cockroaches%20crawling%20on%20kitchen%20surface%20bed%20bugs%20on%20white%20mattress%20ants%20trail%20on%20floor%20realistic%20pest%20infestation%20problem%20professional%20insect%20extermination%20treatment%20spray%20dark%20dramatic%20lighting&width=640&height=1080&seq=hero-desinsectisation-split-01&orientation=portrait"
            alt="Désinsectisation"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
          <div className="absolute bottom-4 left-0 right-0 text-center px-4">
            <div className="inline-flex items-center gap-2 bg-brand-600/90 text-white text-sm font-semibold px-4 py-2 rounded-full">
              <i className="ri-contrast-drop-line"></i> Désinsectisation
            </div>
          </div>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=professional%20worker%20in%20white%20hazmat%20suit%20respirator%20mask%20spraying%20disinfectant%20chemical%20fog%20mist%20inside%20building%20room%20sanitization%20decontamination%20service%20dramatic%20dark%20background%20with%20mist%20particles&width=640&height=1080&seq=hero-desinfection-split-01&orientation=portrait"
            alt="Désinfection"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
          <div className="absolute bottom-4 left-0 right-0 text-center px-4">
            <div className="inline-flex items-center gap-2 bg-brand-600/90 text-white text-sm font-semibold px-4 py-2 rounded-full">
              <i className="ri-plant-line"></i> Désinfection
            </div>
          </div>
        </div>
      </div>

      {/* Overlay global pour lisibilité du texte central */}
      <div className="absolute inset-0 bg-black/30"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center w-full">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight drop-shadow-lg">
          Protection Professionnelle Contre les Nuisibles
        </h1>
        <p className="text-xl md:text-2xl text-white/90 mb-10 max-w-3xl mx-auto drop-shadow">
          Solutions efficaces et durables pour protéger votre environnement des nuisibles avec expertise et respect de l'environnement
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={scrollToContact}
            className="bg-brand-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-brand-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            Demander un Devis Gratuit
          </button>
          <a
            href="tel:+33619794845"
            className="bg-white text-brand-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-50 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <i className="ri-phone-line"></i>
            Appeler Maintenant
          </a>
        </div>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-3 max-w-xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-lg p-3 border border-white/20">
            <div className="w-8 h-8 bg-brand-600 rounded-full flex items-center justify-center mx-auto mb-2">
              <i className="ri-shield-check-line text-sm text-white"></i>
            </div>
            <h3 className="text-sm font-semibold text-white mb-0.5">Certifiés &amp; Agréés</h3>
            <p className="text-white/70 text-xs leading-tight">Professionnels qualifiés et certifiés</p>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-lg p-3 border border-white/20">
            <div className="w-8 h-8 bg-brand-600 rounded-full flex items-center justify-center mx-auto mb-2">
              <i className="ri-time-line text-sm text-white"></i>
            </div>
            <h3 className="text-sm font-semibold text-white mb-0.5">Intervention Rapide</h3>
            <p className="text-white/70 text-xs leading-tight">Disponibles 7j/7 pour urgences</p>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-lg p-3 border border-white/20">
            <div className="w-8 h-8 bg-brand-600 rounded-full flex items-center justify-center mx-auto mb-2">
              <i className="ri-leaf-line text-sm text-white"></i>
            </div>
            <h3 className="text-sm font-semibold text-white mb-0.5">Éco-responsable</h3>
            <p className="text-white/70 text-xs leading-tight">Produits respectueux de l'environnement</p>
          </div>
        </div>
      </div>
    </section>
  );
}
